import { cacheCookieAccess, COOKIE_ACCESS_DELAY } from './cookie';
import { Observable } from './observable';
import * as utils from './utils';
export var SESSION_COOKIE_NAME = '_dd';
export var EXPIRATION_DELAY = 15 * utils.ONE_MINUTE;
/**
 * Limit access to cookie to avoid performance issues
 */
var registeredActivityListeners = [];
export function trackActivity(expandOrRenewSession) {
    var options = { capture: true, passive: true };
    ['click', 'touchstart', 'keydown', 'scroll'].forEach(function (event) {
        document.addEventListener(event, expandOrRenewSession, options);
        registeredActivityListeners.push(function () { return document.removeEventListener(event, expandOrRenewSession, options); });
    });
}
export function stopSessionManagement() {
    registeredActivityListeners.forEach(function (e) { return e(); });
    registeredActivityListeners = [];
}
export function startSessionManagement(cookieName, computeSessionState) {
    var sessionId = cacheCookieAccess(SESSION_COOKIE_NAME);
    var sessionType = cacheCookieAccess(cookieName);
    var renewObservable = new Observable();
    var currentSessionId = sessionId.get();
    var expandOrRenewSession = utils.throttle(function () {
        var _a = computeSessionState(sessionType.get()), type = _a.type, isTracked = _a.isTracked;
        sessionType.set(type, EXPIRATION_DELAY);
        if (!isTracked) {
            return;
        }
        if (sessionId.get()) {
            // If we already have a session id, just expand its duration
            sessionId.set(sessionId.get(), EXPIRATION_DELAY);
        }
        else {
            // Else generate a new session id
            sessionId.set(utils.generateUUID(), EXPIRATION_DELAY);
        }
        // If the session id has changed, notify that the session has been renewed
        if (currentSessionId !== sessionId.get()) {
            currentSessionId = sessionId.get();
            renewObservable.notify();
        }
    }, COOKIE_ACCESS_DELAY);
    expandOrRenewSession();
    trackActivity(expandOrRenewSession);
    return {
        getId: function () {
            return sessionId.get();
        },
        getType: function () {
            return sessionType.get();
        },
        renewObservable: renewObservable,
    };
}
//# sourceMappingURL=sessionManagement.js.map